import { render, staticRenderFns } from "./AccountRecords.vue?vue&type=template&id=1656f600&scoped=true&"
import script from "./AccountRecords.vue?vue&type=script&lang=js&"
export * from "./AccountRecords.vue?vue&type=script&lang=js&"
import style0 from "./AccountRecords.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccountRecords.vue?vue&type=style&index=1&id=1656f600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1656f600",
  null
  
)

export default component.exports